import Vue from 'vue'
import Vuex from 'vuex'
import router from './../router'
// import data from '../data'
import axios from 'axios'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const state = {
  assetsBaseUrl: 'https://api.jauschneg.at/storage/',
  // assetsBaseUrl: 'http://localhost:8888/storage/',
  standort: '',
  error: false,
  isGerman: true,
  isReady: false,
  errorMsg: '',
  cookie: false,
  allTags: [ 1, 2, 3, 4 ],
  loading: false,
  isLogged: false,
  filterContentBy: [],
  filterContent: false,
  content: [],
  en_content: [],
  translationUrl: ''
  // contentLoaded: false
}

const mutations = {
  isReady (state) {
    state.isReady = true
  },
  clearError (state) {
    state.error = false
    state.errorMsg = ''
  },
  setErrorMsg (state, payload) {
    state.error = true
    state.errorMsg = payload
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  changeLang (state) {
    if (state.isGerman) {
      router.push('/studio-jauschneg-home')
    } else {
      router.push('/home')
    }
    state.isGerman = !state.isGerman
  },
  changeLangContent (state) {
    state.isGerman = !state.isGerman
  },
  LOGIN_USER (state) {
    state.isLogged = true
  },
  acceptCookies (state) {
    state.cookie = true
  },
  filterContent (state) {
    state.filterContent = !state.filterContent
  },
  filterContentBy (state, payload) {
    state.filterContent = true
    var i = state.filterContentBy.indexOf(payload)
    if (i === -1) {
      state.filterContentBy.push(payload)
    } else {
      state.filterContentBy.splice(i, 1)
    }
  },
  setFilterBy (state, payload) {
    state.filterContentBy = payload
    state.filterContent = true
  },
  LOGOUT_USER (state) {
    localStorage.removeItem('token')
    localStorage.removeItem('expirationDate')
    localStorage.removeItem('rtoken')
    localStorage.removeItem('rid')
    state.isLogged = false
  },
  fetchContentFrontend (state, payload) {
    state.content = payload
  },
  fetchContentFrontendEn (state, payload) {
    state.en_content = payload
  }
}

const actions = {
  // check if CMS has a valid token saved in local storage
  tryAutoLogin ({commit}) {
    const token = localStorage.getItem('token')
    if (!token) {
      return
    }
    const expirationDate = new Date(localStorage.getItem('expirationDate'))
    const now = new Date()
    if (now >= expirationDate) {
      localStorage.removeItem('token')
      localStorage.removeItem('expirationDate')
      localStorage.removeItem('rtoken')
      localStorage.removeItem('rid')
      return
    }
    commit('LOGIN_USER')
  },
  filterContent ({commit, state}) {
    // reset filter selection if previously set
    if (state.filterContent === true) {
      commit('setFilterBy', [])
    }
    commit('filterContent')
  },
  fetchContentFrontend ({commit}) {
    axios.get('/content/frontend/de')
      .then(function (res) {
        commit('fetchContentFrontend', res.data)
        commit('isReady')
      })
      .catch(function (error) {
        console.log(error)
      })
    axios.get('/content/frontend/en')
      .then(function (res) {
        commit('fetchContentFrontendEn', res.data)
      })
      .catch(function (error) {
        console.log(error)
      })
  }
}

const getters = {
  loading (state) {
    return state.loading
  },
  // assetsBaseUrl (state) {
  //   return state.assetsBaseUrl
  // },
  allTags (state) {
    return state.allTags
  },
  filterContentBy (state) {
    return state.filterContentBy
  },
  assetsBaseUrl (state) {
    return state.assetsBaseUrl
  },
  filterContent (state) {
    return state.filterContent
  },
  error (state) {
    return state.error
  },
  errorMsg (state) {
    return state.errorMsg
  },
  cookie (state) {
    return state.cookie
  },
  isAuthenticated (state) {
    return state.isLogged
  },
  isGerman (state) {
    return state.isGerman
  },
  isReady (state) {
    return state.isReady
  },
  content (state) {
    if (state.isGerman) {
      return state.content
    } else {
      return state.en_content
    }
  },
  getPage (state, getters) {
    return (niceUrl) => {
      return getters.content.find(content => {
        return content.content.seo.niceUrl === niceUrl
      })
    }
  },
  contact () {
    const eins = 'office'
    const zwei = '@'
    const drei = 'jauschneg'
    const vier = 'at'
    return eins + zwei + drei + '.' + vier
  }
}

export default new Vuex.Store({
  // strict: process.env.NODE_ENV !== 'production',
  state,
  mutations,
  actions,
  getters,
  plugins: [createPersistedState()]
})



// WEBPACK FOOTER //
// ./src/store/index.js